import { OrderTableData } from '@teinor/erp/prices/quote/totals'
import { HeaderDataCalculate } from '@teinor/erp/types/company/order/general'
import { CalculateParamsTy } from '../../../baseComponents/Displays/DisplayPrice/types'
import { InputTableLayoutData } from '../../../baseComponents/TwinTable/InputTableLayout/types'
import { parseSelectedTableData } from '../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderTotal/functions'
import { parseOrderTableData } from '../../../specificComponents/inputTableLayouts/order/OrderQuoteLayout/function'
import { getPreparePricesConfigParam } from '../../reducers/getters'

interface OrderTableChildrenLogicProps {
    completeData: InputTableLayoutData
    customParseTableData?: ((completeData: InputTableLayoutData) => OrderTableData)
}

const useOrderCalculateTotals = ({ completeData, customParseTableData }: OrderTableChildrenLogicProps) => {
    const tableData = customParseTableData ? customParseTableData(completeData) : parseSelectedTableData(completeData) as OrderTableData

    const calculateParams = getPreparePricesConfigParam() as CalculateParamsTy
    const headerDataCalculate: HeaderDataCalculate = {
        OrderCosts: completeData.header?.OrderCosts,
        ParamsRoundingDecimals: calculateParams,
        total_recharge_after: completeData.header?.total_recharge_after,
        OrderShipping: completeData.header?.OrderShipping,
        isFinished: completeData.header.isFinished,
        OrderAccounts: completeData.header?.OrderAccounts
    }

    const totalsOrderTableData = parseOrderTableData(tableData, headerDataCalculate)
    return { totalsOrderTableData }
}

export default useOrderCalculateTotals